import { connect } from 'react-redux'
import { compose, defaultProps, withHandlers } from 'recompose'

import { resetState } from 'modules/app/actions'
import { withTheme } from 'modules/util'
import { Argument, Builder, Strongest } from '../../selectors'

import reviewTheme from './theme.scss'

const handleNewGame = props => () => {
  props.resetState()
  window.location = '/'
}

function mapStateToProps(state, props) {
  const id = parseFloat(props.match.params.id)
  const index = Strongest.selected(state)

  return {
    argument: Argument.selected(id, state),
    strongest: Builder.part(index, state)
  }
}

export default compose(
  connect(mapStateToProps, { resetState }),
  defaultProps({ argument: {}, selected: {} }),
  withHandlers({ handleNewGame }),
  withTheme(reviewTheme)
)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Review/enhancers.js